export const MODULE_STORE = [
  { id: 1, type: 'Collection', name: 'Collection' },
  { id: 2, type: 'Delivery', name: 'Delivery' },
];
